module.exports = __webpack_public_path__ + "static/img/49成都印刷.652b989.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/49成都印刷.jpg
// module id = Y2JC
// module chunks = 1